/**
 * @generated SignedSource<<041410f89fb03c05541f12d9d6a1c834>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type src_issueTableHideDoneToggle_HideDoneItemsToggle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HideDoneItemsToggle">;
  readonly " $fragmentType": "src_issueTableHideDoneToggle_HideDoneItemsToggle";
};
export type src_issueTableHideDoneToggle_HideDoneItemsToggle$key = {
  readonly " $data"?: src_issueTableHideDoneToggle_HideDoneItemsToggle$data;
  readonly " $fragmentSpreads": FragmentRefs<"src_issueTableHideDoneToggle_HideDoneItemsToggle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "staticViewInput"
    }
  ],
  "kind": "Fragment",
  "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "staticViewInput",
          "variableName": "staticViewInput"
        }
      ],
      "kind": "FragmentSpread",
      "name": "HideDoneItemsToggle"
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};

(node as any).hash = "274a446d3bfc7669c16bef632e27577f";

export default node;
